export default __webpack_public_path__ + "assets/images/33aeb18d2be1ac6b11dfad6665326ee6.svg";